import SubmoduleSlider from './slider/script';
import SubmoduleHeroWebinar from './hero-webinar/script';

export default {
	[SubmoduleSlider.selector]: SubmoduleSlider,
	[SubmoduleHeroWebinar.selector]: SubmoduleHeroWebinar
};
